import { SubmissionError } from 'redux-form';
import {
    SET_SUBMIT_SERVICE_MESSAGE,
    SET_SUBMIT_CONTACT_MESSAGE,
    SET_SERVICE_SUBMITTING,
    SET_MAIN_CONTACT_SUBMITTING,
    RESET_CAPTCHA
} from './types';
import { submitLead } from '../apis/bskFormsAPI';

const fieldNames = {
    firstName: 'firstName', lastName: 'lastName', email: 'email', phone: 'tel',
    acceptPrivacy: 'souhlas', captchaToken: 'captcharesponse',
    'contact.subject': 'subject', subject: 'subject',
    'contact.message': 'message', message: 'message',
    city: 'city', postalCode: 'zip', address: 'adress',
    'valuation.city': 'city', 'valuation.postalCode': 'zip', 'valuation.address': 'adress',
    'mortgage.city': 'city', 'mortgage.postalCode': 'zip',
    'mortgage.purpose': 'ucel', 'mortgage.fundingSource': 'zdroje',
    'mortgage.fixedRateYears': 'fixace'
};

function toSubmissionError(error) {
    const errors = { _error: error.message || 'Odeslání se nezdařilo.' };
    Object.keys(error.errors || {}).forEach(key => {
        const formField = fieldNames[key];
        if (formField) {
            const messages = error.errors[key];
            errors[formField] = Array.isArray(messages) ? messages[0] : String(messages);
        }
    });
    return new SubmissionError(errors);
}

// Keep Redux Form mounted during transport so failures preserve every editable field.
function submitForm(formType, formData, submittingType, resultType) {
    return async (dispatch, getState) => {
        if (getState().appUI[formType === 'contact' ? 'submittingMainContactData' : 'submittingServiceData']) return;
        dispatch({ type: submittingType, payload: true });
        dispatch({ type: resultType, payload: '' });
        try {
            const result = await submitLead(formType, formData, getState().appUI);
            dispatch({ type: resultType, payload: 'success' });
            return result;
        } catch (error) {
            // A rejected or consumed challenge must be solved again before manual retry.
            dispatch({ type: RESET_CAPTCHA });
            throw toSubmissionError(error);
        } finally {
            dispatch({ type: submittingType, payload: false });
        }
    };
}

export const submitContactData = formData =>
    submitForm('contact', formData, SET_MAIN_CONTACT_SUBMITTING, SET_SUBMIT_CONTACT_MESSAGE);

export const submitMorgageData = formData =>
    submitForm('mortgage', formData, SET_SERVICE_SUBMITTING, SET_SUBMIT_SERVICE_MESSAGE);

export const submitRealEstateEstimateData = formData =>
    submitForm('valuation', formData, SET_SERVICE_SUBMITTING, SET_SUBMIT_SERVICE_MESSAGE);
